import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/wa";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="wa-float-btn"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="wa-pulse fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-4 text-white shadow-2xl shadow-emerald-900/40"
      aria-label="Contattaci su WhatsApp"
    >
      <MessageCircle className="h-6 w-6" strokeWidth={2.2} />
      <span className="hidden sm:inline font-semibold tracking-wide">Scrivici su WhatsApp</span>
    </motion.a>
  );
}
